import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingColorPaletteFromImageConfig } from '@/data/landingConfig/landingColorPaletteFromImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ColorPaletteFromImage } from './schemaObject';

interface Props {}
const ColorPaletteFromImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ColorPaletteFromImage} />
			<LandingTemplate
				data={landingColorPaletteFromImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelColorPicker()}
			/>
		</>
	);
};

export default ColorPaletteFromImage;
